<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary" data-test="listHeader">
        Shuttle Selection - (Step 1 of 8)
    </ion-list-header>

    @if (!hasError()) {
    <ion-list class="ion-text-wrap" data-test="idleShuttles">
        <ion-radio-group data-test="shuttleRadioGroup">
            @for (shuttle of idleShuttles; track $index) {
            <ion-item [disabled]="vb.disabled">
                <ion-label class="ion-text-wrap">
                    <span class="line1">{{shuttle.shuttleName}}</span><br />
                    <span class="line2">Passenger Capacity: {{shuttle.passengerCapacity}}</span>
                </ion-label>
                <ion-radio data-test="shuttleRadio" (click)="onShuttleClick(shuttle)"></ion-radio>
            </ion-item>
            }
        </ion-radio-group>
    </ion-list>
    }

    @if (hasError()) {
    <ion-item class="ion-padding" data-test="errors">
        <p class="errorMsg">{{errMsg}}</p>
    </ion-item>
    }

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext1">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>